export default __webpack_public_path__ + "static/media/bauble.fd81ffd2.png";